import type { TexteVersionCgu } from '@artosera/shared';

/**
 * Textes des CGU, une version par fichier (`textes/<version>.json`), extraits
 * du site par `scripts/cgu.mjs`. Chargés À LA DEMANDE : chaque version est un
 * morceau à part du paquet, que seule la page `/app/conditions` demande — trente
 * kilo-octets de texte juridique n'ont rien à faire dans le lot principal.
 */
const TEXTES = import.meta.glob<TexteVersionCgu>('./textes/*.json', { import: 'default' });

const cheminDe = (version: string) => `./textes/${version}.json`;

/** Les versions dont la régie porte le texte. */
export function versionsDisponibles(): readonly string[] {
  return Object.keys(TEXTES).map((chemin) => chemin.replace(/^\.\/textes\/|\.json$/g, ''));
}

/**
 * Le texte d'une version, ou `null` quand cette régie ne le porte pas — une
 * version plus récente que le paquet servi, par exemple. Une table fermée :
 * la version n'est jamais un chemin.
 */
export async function chargerTexteCgu(version: string): Promise<TexteVersionCgu | null> {
  const charger = Object.hasOwn(TEXTES, cheminDe(version)) ? TEXTES[cheminDe(version)] : undefined;
  return charger ? await charger() : null;
}
